"use client";

import { BSRChevronUp } from "./bsr/BSRChevronUp";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ChevronUp as LegacyChevronUp } from "./legacy/ChevronUp";

export const ChevronUp = createBSRExperimentIcon(LegacyChevronUp, BSRChevronUp);
